export default __webpack_public_path__ + "static/outsource@992_2x-7e5c26f6c73ee827c6bd18498d96769c.webp";